(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!matchMedia('(pointer: coarse)').matches) return;

    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const bind = (media) => {
      if (media.dataset.swipeBound) return;
      media.dataset.swipeBound = 'true';
      const dots = media.parentElement.querySelectorAll('.product-card__swipe-dots span');

      media.addEventListener('scroll', () => {
        const index = Math.round(media.scrollLeft / media.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }, { passive: true });
    };

    // Peek two thirds of the second image on every page load, so shoppers know they can swipe
    // Mandatory scroll-snap would snap a part-way scroll straight back, so snapping is paused for the peek
    const peek = (media) => {
      media.style.scrollSnapType = 'none';
      media.scrollTo({ left: media.clientWidth * 0.66, behavior: 'smooth' });
      setTimeout(() => {
        media.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(() => media.style.removeProperty('scroll-snap-type'), 600);
      }, 3000);
    };

    const init = () => {
      const medias = [...document.querySelectorAll('.product-card__media:has(.product-card__image--secondary)')];
      medias.forEach(bind);

      if (reduceMotion || !medias.length) return;

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.intersectionRatio >= 0.99)) return;
        observer.disconnect();
        setTimeout(() => peek(medias[0]), 600);
      }, { threshold: 0.99 });

      // Peek the first card in the grid once the whole card is on screen
      observer.observe(medias[0].closest('product-card') || medias[0]);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Collection filtering/pagination re-renders the grid
    new MutationObserver(() => document.querySelectorAll('.product-card__media:has(.product-card__image--secondary)').forEach(bind))
      .observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
